<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align: center;">I wish to thank my friend, teacher, and editor Dr. Sandra Alfonsi. She taught me how to create the visual descriptions of my characters, their thoughts and speech patterns and their interactions with other characters. Without her patience and belief in me, this and other books would not<br/>
have been written, understood or published.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?18f19e1c